import _ from "../../../shared/utils/lodash";
import placeTypeUtils from "./placeTypeUtils";
var isContinent = placeTypeUtils.isContinent, isCountry = placeTypeUtils.isCountry, isCity = placeTypeUtils.isCity, isNeighborhood = placeTypeUtils.isNeighborhood, isRegion = placeTypeUtils.isRegion;
function buildPlaceDimensions(places) {
    if (places === void 0) { places = []; }
    var continent = _.find(places, isContinent);
    var country = _.find(places, isCountry);
    var city = _.find(places, isCity);
    var neighborhood = _.find(places, isNeighborhood);
    var region = _.find(places, isRegion);
    var placeDimensions = {
        cd1_Continent: continent ? continent.name : null,
        cd2_Country: country ? country.name : null,
        cd3_City: city ? city.name : null,
        cd4_Neighborhood: neighborhood ? neighborhood.name : null,
        cd5_Region: region ? region.name : null,
        city_atlas_id: city ? city.id : null,
    };
    return placeDimensions;
}
export default buildPlaceDimensions;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/buildPlaceDimensions.ts
// module id = kbrp
// module chunks = 2